import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { Card } from '@ovComponents/2-component/card/card';
import {
  DataTable,
  type DataTableTanstackTable,
  type RowsPerPageOption,
} from '@ovComponents/2-component/dataTable';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import type { FlagGlossaryRowView } from '../utils/flagGlossary.types';

export type FlagGlossaryGridCardProps = {
  table: DataTableTanstackTable<FlagGlossaryRowView>;
  pageSize: RowsPerPageOption;
  tableLoading: boolean;
  gridQueryLoading: boolean;
  hasActiveFilters: boolean;
  hasError: boolean;
};

export const FlagGlossaryGridCard = ({
  table,
  pageSize,
  tableLoading,
  gridQueryLoading,
  hasActiveFilters,
  hasError,
}: FlagGlossaryGridCardProps) => {
  const { t } = useTranslation(['reconciliation']);

  const emptyTitleKey = hasError
    ? 'flagGlossary.emptyTableError'
    : hasActiveFilters
      ? 'flagGlossary.emptyTable'
      : 'flagGlossary.emptyTableNoResults';
  const emptyHintKey = hasError
    ? 'flagGlossary.emptyTableErrorHint'
    : hasActiveFilters
      ? 'flagGlossary.emptyTableHint'
      : 'flagGlossary.emptyTableNoData';

  return (
    <Card loading={gridQueryLoading}>
      <Box sx={{ overflowX: 'auto' }}>
        <DataTable
          table={table}
          rowsPerPage={pageSize}
          loading={tableLoading}
          emptyContent={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                py: 6,
                gap: 0.5,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <InfoRoundedIcon sx={{ mr: 1 }} />
                <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
                  {t(emptyTitleKey)}
                </Typography>
              </Box>
              <Typography
                variant='bodyMedium'
                sx={{ fontWeight: 500 }}
                color='textSecondary'
              >
                {t(emptyHintKey)}
              </Typography>
            </Box>
          }
          tablePagination={{
            mode: 'tanstack',
            ovVariant: 'tableFooter',
            showPerPageSelect: true,
          }}
        />
      </Box>
    </Card>
  );
};
